import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import { UserOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import axiosInstance from "../configs";
import { getUser } from "../utils/DataUser";

// Komponen ini akan ditampilkan setelah login jika profil belum lengkap
export default function ProfileNotification() {
    const [visible, setVisible] = useState(false);
    const [message, setMessage] = useState("");
    const history = useHistory();
    const user = getUser();

    useEffect(() => {
        const checkProfile = async () => {
            if (!user?.id_user) return;

            // Cek apakah sudah pernah dismiss hari ini
            const dismissedKey = `profile_dismiss_${user.id_user}`;
            const dismissedAt = localStorage.getItem(dismissedKey);
            if (dismissedAt) {
                const dismissDate = new Date(dismissedAt);
                const now = new Date();
                // Jika sudah dismiss hari ini, skip
                if (dismissDate.toDateString() === now.toDateString()) {
                    return;
                }
            }

            try {
                const res = await axiosInstance.get(`/user-detail/check/${user.id_user}`);
                if (res.data && !res.data.isComplete) {
                    setMessage(res.data.message || "Profil belum lengkap");
                    setVisible(true);
                }
            } catch (err) {
                console.error("Check profile error:", err);
            }
        };

        // Delay check sedikit untuk memastikan halaman sudah load
        const timer = setTimeout(checkProfile, 1500);
        return () => clearTimeout(timer);
    }, [user?.id_user]);

    const handleGoToProfile = () => {
        setVisible(false);
        history.push("/profile");
    };

    const handleDismiss = () => {
        // Simpan bahwa user sudah dismiss hari ini
        const dismissedKey = `profile_dismiss_${user?.id_user}`;
        localStorage.setItem(dismissedKey, new Date().toISOString());
        setVisible(false);
    };

    return (
        <Modal
            open={visible}
            title={
                <span>
                    <ExclamationCircleOutlined style={{ color: "#faad14", marginRight: 8 }} />
                    Lengkapi Profil Anda
                </span>
            }
            closable={false}
            footer={[
                <Button key="later" onClick={handleDismiss}>
                    Nanti Saja
                </Button>,
                <Button
                    key="go"
                    type="primary"
                    icon={<UserOutlined />}
                    onClick={handleGoToProfile}
                >
                    Lengkapi Profil Sekarang
                </Button>
            ]}
        >
            <p style={{ marginBottom: 16 }}>
                <strong>{message}</strong>
            </p>
            <p>
                Untuk pengalaman yang lebih baik, silakan lengkapi data profil Anda di menu <strong>My Profile</strong>

            </p>
            <p style={{ color: "#888", fontSize: 12 }}>
                Data profil dibutuhkan untuk keperluan komunikasi dan operasional sistem. <br /> Pastikan email yang terdaftar menggunakan email <strong>@atlantiklogistikberikat.com  </strong>
            </p>
        </Modal>
    );
}
